import { createFileRoute } from '@tanstack/react-router';
import { ProposeSemanticModelPage } from '@/features/metric-hub/semantic-models/ProposeSemanticModelPage';

export const Route = createFileRoute('/_authed/metric-hub/semantic-models/$name_/propose-version')({
  component: RouteComponent,
});

function RouteComponent() {
  const { name } = Route.useParams();
  return <ProposeSemanticModelPage fromName={name} />;
}
